import { useMutation, UseMutationOptions } from 'react-query';

import { getRequest } from 'services/apiRequests';
import type { SPMPrefetchRecordsParams, SPMPrefetchRecordsResponse } from 'types/SPM/spmRecords';
import type { APIError } from 'utils/errors';

const prefetchApiUrl = (params: SPMPrefetchRecordsParams) => {
  const { planningCycleId, spmModelId, worksheetId } = params;
  let baseUrl: string;
  if (spmModelId) {
    baseUrl = `/api/v1/spm/planning-cycles/${planningCycleId}/spm-models/${spmModelId}/worksheets/${worksheetId}/records/prefetch-records/`;
  } else {
    baseUrl = `/api/v1/spm/planning-cycles/${planningCycleId}/worksheets/${worksheetId}/records/prefetch-records/`;
  }
  const searchParams = new URLSearchParams();
  if (params.scenarioId) {
    searchParams.set('scenario_id', params.scenarioId);
  }
  // We need scenario to properly get the proposed change (it's scoped to a scenario)
  if (params.scenarioId && params.proposedChangeGroupId) {
    searchParams.set('change_group_id', params.proposedChangeGroupId);
  }
  if (params.columnFilters) {
    searchParams.set('column_filters', JSON.stringify(params.columnFilters));
  }

  return `${baseUrl}?${searchParams.toString()}`;
};

const prefetchSPMRecords = (params: SPMPrefetchRecordsParams) => {
  const url = prefetchApiUrl(params);
  return getRequest<null, SPMPrefetchRecordsResponse>(url);
};

export const usePrefetchSPMRecordsMutation = (
  options: UseMutationOptions<SPMPrefetchRecordsResponse, APIError, SPMPrefetchRecordsParams> = {},
) => {
  return {
    mutation: useMutation<SPMPrefetchRecordsResponse, APIError, SPMPrefetchRecordsParams>(prefetchSPMRecords, options),
  };
};
